export default function UserIcon({
  width = "15px",
  stroke = "#667085",
  hasNotification,
}) {
  return (
    <>
      <svg
        width={width}
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.5 8.58333C16.5029 9.68322 16.2459 10.7682 15.75 11.75C15.162 12.9264 14.2581 13.916 13.1395 14.6077C12.021 15.2995 10.7319 15.6662 9.41667 15.6667C8.31678 15.6695 7.23176 15.4126 6.25 14.9167L1.5 16.5L3.08333 11.75C2.58744 10.7682 2.33047 9.68322 2.33333 8.58333C2.33384 7.26812 2.70051 5.97904 3.39227 4.86045C4.08402 3.74187 5.07355 2.83797 6.25 2.24999C7.23176 1.7541 8.31678 1.49713 9.41667 1.49999H9.83333C11.5703 1.59582 13.2109 2.32896 14.4409 3.55904C15.671 4.78912 16.4042 6.4297 16.5 8.16666V8.58333Z"
          stroke={stroke}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      {hasNotification && (
        <svg
          width="11"
          height="11"
          viewBox="0 0 11 11"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ position: "relative", left: "-10px" }}
        >
          <rect
            x="1"
            y="1"
            width="9"
            height="9"
            rx="4.5"
            fill="#d00f08"
            stroke="white"
            strokeWidth="2"
          />
        </svg>
      )}
    </>
  );
}
